export enum FileAttachmentPermissionMode {
    READ= 'READ',
    READANDWRITE = 'READANDWRITE'
}
